import { render, staticRenderFns } from "./goodCourse.vue?vue&type=template&id=35609630&scoped=true"
import script from "./goodCourse.vue?vue&type=script&lang=js"
export * from "./goodCourse.vue?vue&type=script&lang=js"
import style0 from "./goodCourse.vue?vue&type=style&index=0&id=35609630&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35609630",
  null
  
)

export default component.exports